import React, { useEffect } from "react";
import ClientHeader from "../../client-header/components/index";
import ClientFooter from "../../client-footer/components/index";

const ClientCommunity = () => {

  useEffect(() => {
    // Ensure jQuery and OwlCarousel are loaded
    if (window.$ && window.$.fn.owlCarousel) {
      const $ = window.$;
      const owl = $(".owl-carousel");

      owl.owlCarousel({
        loop: true,
        margin: 20,
        nav: false,
        dots: false,
        autoplay: true,
        autoplayTimeout: 8000,
        responsive: {
          0: { items: 1 },
          500: { items: 2 },
          992: { items: 3 },
          1200: { items: 4 },
        },
      });
  
      $(".owl-prev").click(function () {
        owl.trigger("prev.owl.carousel");
      });
  
      $(".owl-next").click(function () {
        owl.trigger("next.owl.carousel");
      });
    } else {
      console.warn("jQuery or OwlCarousel is not loaded.");
    }
  }, []);

  return (
    <>
      <style>
        {`
          .get-started-button {
            width: 300px !important;
          }
          .card-hover {
            position: relative;
            overflow: hidden;
          }
          .card-hover::before {
            content: "";
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
            top: 10%; /* <-- Increased height of overlay (was 50%) */
            background: linear-gradient(to top, rgba(0, 0, 0, 0.9), transparent);
            z-index: 1;
            pointer-events: none;
            border-radius: inherit;
          }
          .card-overlay {
            z-index: 1;
            padding-bottom: 5px !important;
          }
        `}
      </style>
      <ClientHeader />
      <main className="overflow-hidden">
        <section className="homepad-community mt-1">
          <div className="container">
            <div className="row mb-4 pb-1">
              <div className="col-12 text-center">
                <h2 className="font-weight-bold montserrat text-primary font-size-50 my-4 line-hight-2">
                  JGF Community Forum
                </h2>
                <p className="font-size-16 text-dark">Where families, caregivers, and providers support each other through shared experience, advice, and encouragement.</p>
              </div>
            </div>
            {/* Carousel + Controls */}
            <div className="carousel-container">
              <div className="owl-carousel owl-theme chooseyour-row">
                <div className="card-hover position-relative overflow-hidden">
                  <img src="/assets/images/chooseyour-role01.jpg" alt="Sarah" />
                  <div className="card-overlay position-absolute Bottom-0 start-0 end-0 text-white">
                    <h5 className="font-size-18 font-weight-bold montserrat text-white line-hight-1">🎉 Welcome Lounge</h5>
                  </div>
                  <div className="chooseyour-card position-absolute text-white d-flex flex-column p-4">
                    <div className="lh-base font-size-16">
                      <p>“New member intros, community announcements, forum rules.”</p>
                    </div>
                    <div className="mt-auto">
                      <h6 className="font-size-18 font-weight-bold montserrat text-white mb-4 line-hight-1">Access</h6>
                      <div className="tag-list font-size-14">
                        <span className="d-inline-block mb-2"><a href="#" className="btn text-primary font-weight-medium rounded-pill bg-white">All roles</a></span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-hover position-relative overflow-hidden">
                  <img src="/assets/images/chooseyour-role02.jpg" alt="Sarah" />
                  <div className="card-overlay position-absolute Bottom-0 start-0 end-0 text-white">
                    <h5 className="font-size-18 font-weight-bold montserrat text-white mb-3 line-hight-1">👪 Parent-to-Parent</h5>
                  </div>
                  <div className="chooseyour-card position-absolute text-white d-flex flex-column p-4">
                    <div className="lh-base font-size-16">
                      <p>“Ask questions, share strategies, celebrate wins.”</p>
                    </div>
                    <div className="mt-auto">
                      <h6 className="font-size-18 font-weight-bold montserrat text-white mb-4 line-hight-1">Access</h6>
                      <div className="tag-list font-size-14">
                        <span className="d-inline-block mb-2"><a href="#" className="btn text-primary font-weight-medium rounded-pill bg-white">Parents only</a></span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-hover position-relative overflow-hidden">
                  <img src="/assets/images/chooseyour-role03.jpg" alt="Sarah" />
                  <div className="card-overlay position-absolute Bottom-0 start-0 end-0 text-white">
                    <h5 className="font-size-18 font-weight-bold montserrat text-white mb-3 line-hight-1">👩⚕️ Caregiver Hub</h5>
                  </div>
                  <div className="chooseyour-card position-absolute text-white d-flex flex-column p-4">
                    <div className="lh-base font-size-16">
                      <p>“Daily routines, challenging behaviors, sharing visuals/tools.”</p>
                    </div>
                    <div className="mt-auto">
                      <h6 className="font-size-18 font-weight-bold montserrat text-white mb-4 line-hight-1">Access</h6>
                      <div className="tag-list font-size-14">
                        <span className="d-inline-block mb-2"><a href="#" className="btn text-primary font-weight-medium rounded-pill bg-white">Caregivers only</a></span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-hover position-relative overflow-hidden">
                  <img src="/assets/images/chooseyour-role01.jpg" alt="Sarah" />
                  <div className="card-overlay position-absolute Bottom-0 start-0 end-0 text-white">
                    <h5 className="font-size-18 font-weight-bold montserrat text-white mb-3 line-hight-1">🏫 Provider Circle</h5>
                  </div>
                  <div className="chooseyour-card position-absolute text-white d-flex flex-column p-4">
                    <div className="lh-base font-size-16">
                      <p>“Lesson planning, inclusive classrooms, IEP alignment.”</p>
                    </div>
                    <div className="mt-auto">
                      <h6 className="font-size-18 font-weight-bold montserrat text-white mb-4 line-hight-1">Access</h6>
                      <div className="tag-list font-size-14">
                        <span className="d-inline-block mb-2"><a href="#" className="btn text-primary font-weight-medium rounded-pill bg-white">Providers only</a></span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-hover position-relative overflow-hidden">
                  <img src="/assets/images/chooseyour-role02.jpg" alt="Sarah" />
                  <div className="card-overlay position-absolute Bottom-0 start-0 end-0 text-white">
                    <h5 className="font-size-18 font-weight-bold montserrat text-white mb-3 line-hight-1">🧠 Ask a Specialist</h5>
                  </div>
                  <div className="chooseyour-card position-absolute text-white d-flex flex-column p-4">
                    <div className="lh-base font-size-16">
                      <p>“Submit questions to volunteer speech/OT/developmental experts.”</p>
                    </div>
                    <div className="mt-auto">
                      <h6 className="font-size-18 font-weight-bold montserrat text-white mb-4 line-hight-1">Access</h6>
                      <div className="tag-list font-size-14">
                        <span className="d-inline-block mb-2"><a href="#" className="btn text-primary font-weight-medium rounded-pill bg-white">All roles</a></span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-hover position-relative overflow-hidden">
                  <img src="/assets/images/chooseyour-role02.jpg" alt="Sarah" />
                  <div className="card-overlay position-absolute Bottom-0 start-0 end-0 text-white">
                    <h5 className="font-size-18 font-weight-bold montserrat text-white mb-3 line-hight-1">📥 Download & Share Zone</h5>
                  </div>
                  <div className="chooseyour-card position-absolute text-white d-flex flex-column p-4">
                    <div className="lh-base font-size-16">
                      <p>“User-contributed visuals, schedules, checklists (mod-approved).”</p>
                    </div>
                    <div className="mt-auto">
                      <h6 className="font-size-18 font-weight-bold montserrat text-white mb-4 line-hight-1">Access</h6>
                      <div className="tag-list font-size-14">
                        <span className="d-inline-block mb-2"><a href="#" className="btn text-primary font-weight-medium rounded-pill bg-white">All roles</a></span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-hover position-relative overflow-hidden">
                  <img src="/assets/images/chooseyour-role02.jpg" alt="Sarah" />
                  <div className="card-overlay position-absolute Bottom-0 start-0 end-0 text-white">
                    <h5 className="font-size-18 font-weight-bold montserrat text-white mb-3 line-hight-1">🎤 Stories That Inspire</h5>
                  </div>
                  <div className="chooseyour-card position-absolute text-white d-flex flex-column p-4">
                    <div className="lh-base font-size-16">
                      <p>“Family wins, child breakthroughs, uplifting stories.”</p>
                    </div>
                    <div className="mt-auto">
                      <h6 className="font-size-18 font-weight-bold montserrat text-white mb-4 line-hight-1">Access</h6>
                      <div className="tag-list font-size-14">
                        <span className="d-inline-block mb-2"><a href="#" className="btn text-primary font-weight-medium rounded-pill bg-white">All roles</a></span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-hover position-relative overflow-hidden">
                  <img src="/assets/images/chooseyour-role02.jpg" alt="Sarah" />
                  <div className="card-overlay position-absolute Bottom-0 start-0 end-0 text-white">
                    <h5 className="font-size-18 font-weight-bold montserrat text-white mb-3 line-hight-1">🚩 Report or Flag Content</h5>
                  </div>
                  <div className="chooseyour-card position-absolute text-white d-flex flex-column p-4">
                    <div className="lh-base font-size-16">
                      <p>“Form to flag abuse or harmful content.”</p>
                    </div>
                    <div className="mt-auto">
                      <h6 className="font-size-18 font-weight-bold montserrat text-white mb-4 line-hight-1">Access</h6>
                      <div className="tag-list font-size-14">
                        <span className="d-inline-block mb-2"><a href="#" className="btn text-primary font-weight-medium rounded-pill bg-white">Admin-only response</a></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Custom Controls */}
            <div className="carousel-controls carousel-arrow text-center mt-4 pt-3">
              <button className="owl-prev bg-white me-2"><i className="fa fa-chevron-left" aria-hidden="true"></i></button>
              <button className="owl-next bg-white"><i className="fa fa-chevron-right" aria-hidden="true"></i></button>
            </div>
          </div>
        </section>

        <section className="homepad pt-0 mt-0">
          <div className="container">
            <h3 className="font-weight-bold montserrat text-primary font-size-40 mb-3 mb-lg-4 pb-lg-1 line-hight-2 text-center text-lg-start">Permissions & Safety</h3>
            <div className="table-responsive">
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>Role</th>
                    <th>Can Post</th>
                    <th>Can View</th>
                    <th>Notes</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Guest</td>
                    <td>❌</td>
                    <td>Partial</td>
                    <td>View FAQs or intro forum only</td>
                  </tr>
                  <tr>
                    <td>Parent</td>
                    <td>✅</td>
                    <td>✅</td>
                    <td>Posts in Parent, Ask a Specialist</td>
                  </tr>
                  <tr>
                    <td>Caregiver</td>
                    <td>✅</td>
                    <td>✅</td>
                    <td>Posts in Caregiver, Shared Zones</td>
                  </tr>
                  <tr>
                    <td>Provider</td>
                    <td>✅</td>
                    <td>✅</td>
                    <td>Posts in Provider, Shared Zones</td>
                  </tr>
                  <tr>
                    <td>Admin</td>
                    <td>✅</td>
                    <td>✅</td>
                    <td>Full moderation, pin posts, delete</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </section>

        <section className="homepad pt-0 mt-0">
          <div className="container">
            <div className="row">
              <div className="col-lg-8">
                <h3 className="font-weight-bold montserrat text-primary font-size-40 mb-3 mb-lg-4 pb-lg-1 line-hight-2 text-center text-lg-start">Backend/Integration Options</h3>
                <div className="row whychoose-row justify-content-center row-cols-1 row-cols-md-2 g-3">
                  <div className="col col-transition">
                    <div className="card bg-light border-0 h-100 rounded whychoose-box text-center">
                      <div className="card-body">
                        <div className="p-1">
                          <img src="/assets/images/how-it-work01.svg" alt="..." className="" />
                          <h4 className="font-weight-bold montserrat mb-3 mb-lg-4 pt-1 mt-3 mt-lg-4 text-dark font-size-22 line-hight-1">Discourse </h4>
                          <p className="card-text font-size-16 text-muted font-weight-normal line-hight-3">
                            <strong>Use: </strong>Full-featured, open source
                          </p>
                          <p className="card-text font-size-16 text-muted font-weight-normal line-hight-3">
                            <strong>Note: </strong>Best for custom themes
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col col-transition">
                    <div className="card bg-light border-0 h-100 rounded whychoose-box text-center">
                      <div className="card-body">
                        <div className="p-1">
                          <img src="assets/images/how-it-work02.svg" alt="..." className="" />
                          <h4 className="font-weight-bold montserrat mb-3 mb-lg-4 pt-1 mt-3 mt-lg-4 text-dark font-size-22 line-hight-1">Flarum </h4>
                          <p className="card-text font-size-16 text-muted font-weight-normal line-hight-3">
                            <strong>Use: </strong>Lightweight, mobile-friendly
                          </p>
                          <p className="card-text font-size-16 text-muted font-weight-normal line-hight-3">
                            <strong>Note: </strong>Easy Laravel integration
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col col-transition">
                    <div className="card bg-light border-0 h-100 rounded whychoose-box text-center">
                      <div className="card-body">
                        <div className="p-1">
                          <img src="/assets/images/how-it-work03.svg" alt="..." className="" />
                          <h4 className="font-weight-bold montserrat mb-3 mb-lg-4 pt-1 mt-3 mt-lg-4 text-dark font-size-22 line-hight-1">BuddyBoss / bbPress</h4>
                          <p className="card-text font-size-16 text-muted font-weight-normal line-hight-3">
                            <strong>Use: </strong>WordPress plugin
                            </p>
                          <p className="card-text font-size-16 text-muted font-weight-normal line-hight-3">
                            <strong>Note: </strong>If WP-based site
                            </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col col-transition">
                    <div className="card bg-light border-0 h-100 rounded whychoose-box text-center">
                      <div className="card-body">
                        <div className="p-1">
                          <img src="/assets/images/how-it-work03.svg" alt="..." className="" />
                          <h4 className="font-weight-bold montserrat mb-3 mb-lg-4 pt-1 mt-3 mt-lg-4 text-dark font-size-22 line-hight-1">Circle.so or Tribe.so</h4>
                          <p className="card-text font-size-16 text-muted font-weight-normal line-hight-3">
                            <strong>Use: </strong>Hosted, branded solution
                          </p>
                          <p className="card-text font-size-16 text-muted font-weight-normal line-hight-3">
                            <strong>Note: </strong>Monthly fee
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>  
                </div>
              </div>
              <div className="col-lg-4 mt-4 mt-lg-0 pt-2 pt-lg-0">
                <img src="/assets/images/how-it-work-img.jpg" alt="..." className="w-100 how-it-work-img" />
              </div>
            </div>
          </div>
        </section>

        <section className="homepad-community">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6">
                <div className="position-relative">
                  <img src="/assets/images/about-img.jpg" alt="..." className="w-100 about-img" />
                </div>
              </div>
              <div className="col-lg-6 font-size-16 font-weight-normal line-hight-3 text-muted mt-4 mt-lg-0 pt-3 pt-lg-0">
                <div className="ps-lg-4 ps-xl-5">
                  <div>
                    <div className="bg-primary-heading font-weight-semibold font-size-18 text-capitalize p-1 rounded-pill d-inline-block text-white pe-4">
                      <span className="bg-yellow d-inline-block p-1 bg-primary-heading rounded-pill favicon-logo01 text-center me-2">
                        {/* <img src="/assets/images/favicon-logo01.svg" alt="..." className="rounded-circle" /> */}
                        <span className="rounded-circle">💬</span>
                      </span>
                      Thread View Layout
                    </div>
                  </div>     
                  <p className="mt-3 mb-1">
                    <span>
                      •	Post Title
                    </span>
                  </p>
                  <p className="mt-0 mb-1">
                    <span>
                      •	User Info (Name, Role, Avatar, Join Date)
                    </span>
                  </p>
                  <p className="mt-0">
                    <span>
                      •	Post Content (with rich text formatting)
                    </span>
                  </p>
                  <div className="mt-5">
                    <div className="bg-primary-heading font-weight-semibold font-size-18 text-capitalize p-1 rounded-pill d-inline-block text-white pe-4">
                      <span className="bg-yellow d-inline-block p-1 bg-primary-heading rounded-pill favicon-logo01 text-center me-2">
                        {/* <img src="/assets/images/favicon-logo01.svg" alt="..." className="rounded-circle" /> */}
                        <span className="rounded-circle">✨</span>
                      </span>
                        Bonus Add-Ons
                    </div>
                  </div>
                  <p className="mt-3 mb-1">
                    <span>
                      •	Weekly moderator “Topic of the Week”
                    </span>
                  </p>
                  <p className="mt-0 mb-1">
                    <span>
                      •	Monthly Zoom “Virtual Support Circle”
                    </span>
                  </p>
                  <p className="mt-0 mb-1">
                    <span>
                      •	Community badge program (“JGF Uplifter,” “Storyteller”)
                    </span>
                  </p>
                  <p className="mt-0">
                    <span>
                      •	Automated onboarding post: “Welcome! Start here…”
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <ClientFooter />
    </>
  );
};

export default ClientCommunity;
